<template>
  <!--
    เมนูกระบวนการครูผู้ช่วย (ส่วนกลาง) — ใช้ร่วมโดย assistant_teacher_bar.vue / manageAssistantTeacherBar.vue (18 หน้า)
    เรียงตามลำดับงานจริง 4 ขั้น + เครื่องมือติดตาม · ไฮไลต์ขั้น/หน้าที่กำลังเปิด · ย่อเหลือแถวเดียวได้ (จำค่าไว้ในเครื่อง)
  -->
  <div class="atn" :class="{ 'atn--collapsed': collapsed }">
    <div class="atn-head">
      <v-icon small class="mr-2" color="#1f3b57">mdi-human-male-board</v-icon>
      <span class="atn-title">กระบวนการครูผู้ช่วย</span>
      <span v-if="current" class="atn-crumb">
        <v-icon x-small class="mx-1">mdi-chevron-right</v-icon>
        <template v-if="currentStage.no">ขั้น {{ currentStage.no }} · </template>{{ currentStage.title }}
        <v-icon x-small class="mx-1">mdi-chevron-right</v-icon>
        <b>{{ current.text }}</b>
      </span>
      <v-spacer />
      <v-btn small outlined color="#1f3b57" class="atn-toggle" @click="toggle">
        <v-icon small left>{{ collapsed ? "mdi-chevron-down" : "mdi-chevron-up" }}</v-icon>
        {{ collapsed ? "แสดงเมนูทั้งหมด" : "ย่อเมนู" }}
      </v-btn>
    </div>

    <!-- ย่อ: แถวขั้นตอนเดียว กดเพื่อไปหน้าแรกของขั้นนั้น -->
    <div v-if="collapsed" class="atn-strip">
      <template v-for="(s, i) in stages">
        <router-link :key="s.key" :to="s.items[0].to" class="atn-chip" :class="{ active: s.key === currentStage.key }">
          <span v-if="s.no" class="atn-num">{{ s.no }}</span>
          <v-icon v-else x-small class="mr-1">{{ s.icon }}</v-icon>
          {{ s.title }}
        </router-link>
        <v-icon v-if="i < stages.length - 2" :key="s.key + '-arrow'" x-small color="#9aa5b1">mdi-chevron-right</v-icon>
      </template>
    </div>

    <!-- เต็ม: คอลัมน์ตามขั้นตอน -->
    <div v-else class="atn-grid">
      <section v-for="s in stages" :key="s.key" class="atn-stage"
        :class="{ active: s.key === currentStage.key, tools: !s.no }">
        <header class="atn-stage-head">
          <span v-if="s.no" class="atn-num">{{ s.no }}</span>
          <v-icon v-else small class="atn-tools-icon">{{ s.icon }}</v-icon>
          <div>
            <div class="atn-stage-title">{{ s.title }}</div>
            <div class="atn-stage-desc">{{ s.desc }}</div>
          </div>
        </header>
        <router-link v-for="it in s.items" :key="it.to" :to="it.to" class="atn-link"
          :class="{ active: current && current.to === it.to }">
          <v-icon small class="atn-link-icon">{{ it.icon }}</v-icon>
          <span>{{ it.text }}</span>
        </router-link>
      </section>
    </div>
  </div>
</template>

<script>
const STORAGE_KEY = "atn_collapsed";

// ลำดับงานตามกระบวนการจริง: เรียกรายงานตัว → กรรมการ → ประเมิน 4 ครั้ง → อนุมัติ คศ.1
const STAGES = [
  {
    key: "report", no: 1, title: "เรียกรายงานตัว", desc: "กำหนดรอบ ตำแหน่งว่าง รับรายงานตัว",
    items: [
      { text: "ปฏิทิน/กำหนดรอบ", icon: "mdi-calendar-clock", to: "/admin/periodassteach" },
      { text: "กำหนดการรายงานตัว", icon: "mdi-calendar-check", to: "/admin/timelines/report_assistantteacher" },
      { text: "เลขที่ตำแหน่งว่าง", icon: "mdi-office-building-marker", to: "/admin/assistant_teacher_report/manage_college_manpower" },
      { text: "จับคู่ตำแหน่ง/รายงาน", icon: "mdi-swap-horizontal", to: "/admin/assistant_teacher_report/teacher_college_manpower_report" },
      { text: "รายชื่อผู้ถูกเรียกรายงานตัว", icon: "mdi-account-details", to: "/admin/manage_assistant_teacher_data" },
      { text: "รายงานตัว ณ สถานศึกษา", icon: "mdi-domain", to: "/admin/assistant_teacher_report/manage_assistant_CollegeReport" },
      { text: "รายงานตัว (โอนย้าย)", icon: "mdi-domain-switch", to: "/admin/assistant_teacher_report/manage_assistant_CollegeReportTran" }
    ]
  },
  {
    key: "committee", no: 2, title: "คณะกรรมการประเมิน", desc: "ผู้ทรงคุณวุฒิ และกรรมการรายคน",
    items: [
      { text: "ทะเบียนผู้ทรงคุณวุฒิ", icon: "mdi-account-star", to: "/admin/assistant_teacher_report/assistantcommitteequalified" },
      { text: "เสนอคณะกรรมการรายคน", icon: "mdi-account-group", to: "/admin/assistant_teacher_report/manage_assistant_teacher_committee" }
    ]
  },
  {
    key: "assess", no: 3, title: "ประเมิน 4 ครั้ง", desc: "ตรวจผลทุก 6 เดือน และใบอนุญาต",
    items: [
      { text: "ตรวจผลการประเมิน", icon: "mdi-clipboard-check-outline", to: "/admin/assistant_teacher" },
      { text: "รายละเอียดรายคน", icon: "mdi-account-search", to: "/admin/assistant_teacher_detail" },
      { text: "ใบอนุญาตประกอบวิชาชีพ", icon: "mdi-certificate-outline", to: "/admin/servey_assistant_specialized_licenses" }
    ]
  },
  {
    key: "approve", no: 4, title: "อนุมัติ ครู คศ.1", desc: "สรุปผล ตรวจเงื่อนไข และอนุมัติ",
    items: [
      { text: "สรุปผล + อนุมัติ คศ.1", icon: "mdi-file-certificate-outline", to: "/admin/assistant_teacher_reports" }
    ]
  },
  {
    key: "tools", no: null, icon: "mdi-radar", title: "ติดตาม / ข้อมูล", desc: "ค้างที่ขั้นไหน ใครต้องทำ",
    items: [
      { text: "ติดตามเส้นทางครูผู้ช่วย", icon: "mdi-transit-connection-variant", to: "/admin/assistant_teacher_monitor" },
      { text: "ข้อมูลย้อนหลัง", icon: "mdi-archive-outline", to: "/admin/assistant_teacher_report/manage_assistant_teacher_backup" }
    ]
  }
];

export default {
  name: "AssistantTeacherProcessNav",
  data() {
    let collapsed = false;
    try {
      collapsed = localStorage.getItem(STORAGE_KEY) === "1";
    } catch (e) {
      // ไม่มี localStorage — ใช้ค่าเริ่มต้น
    }
    return { stages: STAGES, collapsed };
  },
  computed: {
    path() {
      return (this.$route && this.$route.path.replace(/\/+$/, "")) || "";
    },
    current() {
      for (const s of this.stages) {
        const it = s.items.find(i => i.to === this.path);
        if (it) return it;
      }
      return null;
    },
    currentStage() {
      return this.stages.find(s => s.items.some(i => i.to === this.path)) || {};
    }
  },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed;
      try {
        localStorage.setItem(STORAGE_KEY, this.collapsed ? "1" : "0");
      } catch (e) {
        // ไม่บันทึกก็ได้
      }
    }
  }
};
</script>

<style scoped>
.atn {
  --atn-ink: #1f3b57;
  --atn-muted: #6b7785;
  --atn-line: #e3e8ee;
  --atn-accent: #c62828;
  --atn-accent-soft: #fdecec;
  background: #fff;
  border: 1px solid var(--atn-line);
  border-radius: 10px;
  padding: 10px 12px 12px;
  margin-bottom: 16px;
}
.atn-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: 10px;
}
.atn-title {
  font-weight: 700;
  color: var(--atn-ink);
  font-size: 0.95rem;
}
.atn-crumb {
  color: var(--atn-muted);
  font-size: 0.82rem;
}
.atn-crumb b {
  color: var(--atn-accent);
}
.atn-toggle {
  text-transform: none;
  letter-spacing: 0;
  font-size: 0.8rem;
}
.atn--collapsed .atn-head {
  margin-bottom: 8px;
}

/* ---------- เต็ม ---------- */
.atn-grid {
  display: grid;
  grid-template-columns: 1.35fr 1fr 1fr 1fr 1fr;
  gap: 10px;
}
.atn-stage {
  border: 1px solid var(--atn-line);
  border-top: 3px solid #b8c4d0;
  border-radius: 8px;
  padding: 8px 8px 6px;
  background: #fafbfc;
  position: relative;
}
.atn-stage.active {
  border-top-color: var(--atn-accent);
  background: #fff;
  box-shadow: 0 2px 8px rgba(31, 59, 87, 0.08);
}
.atn-stage.tools {
  background: #f4f6f9;
  border-style: dashed;
  border-top-style: solid;
}
.atn-stage:not(.tools):not(:nth-last-child(2))::after {
  /* ลูกศรระหว่างขั้น */
  content: "";
  position: absolute;
  right: -9px;
  top: 18px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #b8c4d0;
  border-right: 2px solid #b8c4d0;
  transform: rotate(45deg);
}
.atn-stage-head {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 6px;
  padding: 0 2px;
}
.atn-num {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--atn-ink);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.atn-stage.active .atn-num,
.atn-chip.active .atn-num {
  background: var(--atn-accent);
}
.atn-tools-icon {
  color: var(--atn-ink) !important;
  margin-top: 2px;
}
.atn-stage-title {
  font-weight: 700;
  color: var(--atn-ink);
  font-size: 0.86rem;
  line-height: 1.25;
}
.atn-stage-desc {
  color: var(--atn-muted);
  font-size: 0.72rem;
  line-height: 1.3;
}
.atn-link {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px;
  border-radius: 6px;
  color: #2f3d4a !important;
  text-decoration: none;
  font-size: 0.8rem;
  line-height: 1.3;
  transition: background 0.15s;
}
.atn-link:hover {
  background: #eef2f6;
}
.atn-link-icon {
  color: #6b7785 !important;
}
.atn-link.active {
  background: var(--atn-accent-soft);
  color: var(--atn-accent) !important;
  font-weight: 700;
}
.atn-link.active .atn-link-icon {
  color: var(--atn-accent) !important;
}

/* ---------- ย่อ ---------- */
.atn-strip {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.atn-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px 3px 4px;
  border: 1px solid var(--atn-line);
  border-radius: 999px;
  color: var(--atn-ink) !important;
  text-decoration: none;
  font-size: 0.8rem;
  background: #fafbfc;
}
.atn-chip:last-child {
  margin-left: auto;
  padding-left: 10px;
  border-style: dashed;
}
.atn-chip.active {
  border-color: var(--atn-accent);
  background: var(--atn-accent-soft);
  color: var(--atn-accent) !important;
  font-weight: 700;
}

@media (max-width: 1263px) {
  .atn-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .atn-stage::after {
    display: none;
  }
}
@media (max-width: 700px) {
  .atn-grid {
    grid-template-columns: 1fr;
  }
  .atn-chip:last-child {
    margin-left: 0;
  }
}
</style>
